import React from 'react';

import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Lodash from 'lodash';
import Moment from 'moment';



export default class NotificationList extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			application: '3ftlLhJYXpVqmP5joDcbVW',
			notifications: [],
			loading: false,
			notificationType: 'sended',
			alertValue: '',
			alertOpen: false,
			excludeId: null,
			confirmationExcludeOpen: false

		};

		this.handleSelectApplication = this.handleSelectApplication.bind(this);
		this.handleSelectNotificationType = this.handleSelectNotificationType.bind(this);
		this.openDialog = this.openDialog.bind(this);
		this.openExcludeDialog = this.openExcludeDialog.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
	}

	componentDidMount() {
		this.fetchNotifications();
	}

	fetchNotifications = () => {
		const { application, notificationType } = this.state;

		this.setState({
			loading: true
		});

		this.props.fetchApi('get', `/notifications?applicationId=${application}&type=${notificationType}`)
			.then((response) => {
				const sorted = response.data.notifications.sort((a, b) => (
					Moment.utc(b.scheduledDate || b.createdAt).diff(Moment.utc(a.scheduledDate || a.createdAt))
				));

				this.setState({
					notifications: sorted,
					loading: false
				})
			}).catch(() => {
				this.props.showSnackbar('Erro ao listar notificações. Tente novamente.');
				this.setState({
					loading: false
				})
			});
	}

	deleteScheduledNotification = (notificationId) => {
		const { application } = this.state;

		this.setState({
			loading: true
		});

		this.closeDialog();

		this.props.fetchApi('delete', `/notifications/${application}/${notificationId}`)
			.then((response) => {
				this.props.showSnackbar('Notificação cancelada com sucesso.');
				this.fetchNotifications();
			}).catch((err) => {
				window.alert('Aconteceu um erro de comunicação com o servidor, mas a notificação ainda pode estar sendo deletada. Espere alguns minutos e procure a notificação na lista, caso ela não apareça, ela foi deletada com sucesso.');
				this.setState({
					loading: false
				})
			});
	}



	openDialog(text) {
		this.setState({
			alertValue: text,
			alertOpen: true
		})
	}

	openExcludeDialog(id) {
		this.setState({
			excludeId: id,
			confirmationExcludeOpen: true
		})
	}

	closeDialog() {
		this.setState({
			alertValue: '',
			alertOpen: false,
			excludeId: null,
			confirmationExcludeOpen: false
		})
	}

	handleSelectApplication(event, index, value) {
		this.setState(() => ({ application: value }), this.fetchNotifications);
	}

	handleSelectNotificationType(event, index, value) {
		this.setState(() => ({ notificationType: value }), this.fetchNotifications);
	}

	render() {

		const { application, notifications, loading, notificationType, alertValue, alertOpen, confirmationExcludeOpen } = this.state;
		return (
			<div>
				<br />
				<br />
				<Card style={{ padding: '1rem' }}>
					<Typography color="textSecondary" gutterBottom>
						Lista de notificações
        			</Typography>
					<br />
					<InputLabel shrink >
						Aplicação
					</InputLabel>
					<Select
						value={application}
						onChange={(event) => this.handleSelectApplication(event, null, event.target.value)}
					>
						<MenuItem value="3ftlLhJYXpVqmP5joDcbVW">
							OAB de Bolso
							</MenuItem>
						<MenuItem value="40yXWykpgaVGXsnXrT8nCc">
							Concursos de Bolso
							</MenuItem>
					</Select>
					<br />
					<br />
					<InputLabel shrink >
						Filtrar
					</InputLabel>
					<Select
						value={notificationType}
						onChange={(event) => this.handleSelectNotificationType(event, null, event.target.value)}
					>
						<MenuItem value="sended">
							Notificações Enviadas
						</MenuItem>
						<MenuItem value="scheduled">
							Notificações Agendadas
						</MenuItem>
					</Select>

					<Dialog open={alertOpen} onClose={() => { this.closeDialog() }}>
						<DialogContent>
							<DialogContentText >
								{alertValue}
							</DialogContentText>
						</DialogContent>
					</Dialog>

					<Dialog open={confirmationExcludeOpen} onClose={() => { this.closeDialog() }}>
						<DialogTitle>{"Cancelar notificação?"}</DialogTitle>
						<DialogContent>
							<DialogContentText >
								Tem certeza que deseja cancelar essa notificação? Ela não podera ser recuperada depois.
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={() => this.closeDialog()} color="primary">
								Não
          					</Button>
							<Button onClick={() => this.deleteScheduledNotification(this.state.excludeId)} color="primary">
								Sim
          					</Button>
						</DialogActions>
					</Dialog>
					<br />
					{loading
						?
						<CircularProgress style={{ marginLeft: '1rem' }} />

						: (

							<TableContainer component={Paper}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell >Título</TableCell>
											<TableCell >Texto</TableCell>
											<TableCell >Texto do botão</TableCell>
											{notificationType !== 'scheduled' &&
												<TableCell >Clicks</TableCell>
											}
											<TableCell>Enviadas</TableCell>
											<TableCell width='20'>URL</TableCell>
											<TableCell>Data de Envio</TableCell>
											<TableCell>Segmento</TableCell>
											{notificationType === 'scheduled' &&
												<TableCell>Ação</TableCell>
											}
										</TableRow>
									</TableHead>
									<TableBody >
										{notifications.map((notification) => (
											<TableRow key={notification.id}>
												<TableCell onClick={() => { this.openDialog(notification.title) }} title={notification.title}>
													{notification.title.length <= 40 ? notification.title : notification.title.substring(0, 40) + '...'}

												</TableCell>
												<TableCell onClick={() => { this.openDialog(notification.body) }} title={notification.body}>
													{notification.body.length <= 70 ? notification.body : notification.body.substring(0, 70) + '...'}

												</TableCell>

												<TableCell
													onClick={() => { 
														let text = JSON.parse(notification.jsonPayload) ? (	JSON.parse(notification.jsonPayload).confirmButtonName ) : ''
														this.openDialog(text) 
													}} 
													title={
														!typeof JSON.parse(notification.jsonPayload) === 'null' && !typeof JSON.parse(notification.jsonPayload).confirmButtonName === 'undefined' ? JSON.parse(notification.jsonPayload).confirmButtonName : ''
													}
												>
													{
														!typeof JSON.parse(notification.jsonPayload) === 'null' && !typeof JSON.parse(notification.jsonPayload).confirmButtonName === 'undefined' ? (	JSON.parse(notification.jsonPayload).confirmButtonName.length <= 70 ? JSON.parse(notification.jsonPayload).confirmButtonName : JSON.parse(notification.jsonPayload).confirmButtonName.substring(0, 70) + '...') : ''
													}
												</TableCell>
												{notificationType !== 'scheduled' &&
													<TableCell style={{ textAlign: 'right' }}>{notification.clicks ? notification.clicks : 0}</TableCell>
												}
												<TableCell style={{ textAlign: 'center' }}>{
													notification.sentCount
												}</TableCell>
												<TableCell onClick={() => { this.openDialog(JSON.parse(notification.jsonPayload).url) }} title={
													notification.jsonPayload !== null && JSON.parse(notification.jsonPayload).type === 'url'
														? JSON.parse(notification.jsonPayload).url
														: ''
												}>
													<a href={notification.jsonPayload !== null && JSON.parse(notification.jsonPayload).type === 'url'
														? JSON.parse(notification.jsonPayload).url
														: ''}>{
															notification.jsonPayload !== null && JSON.parse(notification.jsonPayload).type === 'url'
																? (JSON.parse(notification.jsonPayload).url).length <= 60 ? (JSON.parse(notification.jsonPayload).url) : (JSON.parse(notification.jsonPayload).url).substring(0, 30) + '...'
																: ''
														}</a>
												</TableCell>
												<TableCell >
													{Moment(notification.scheduledDate || notification.createdAt).format('HH:mm - DD/MM/YYYY')}
												</TableCell>
												<TableCell
													title={

														Lodash.get(notification, 'tags', []).find(tag => tag.name.includes('mauticSegment')) !== undefined
															? Lodash.get(notification, 'tags', []).find(tag => tag.name.includes('mauticSegment')).name.replace('mauticSegment_', '').replace(/&/g, ',')
															: ""
													}
												>{
														Lodash.get(notification, 'tags', []).find(tag => tag.name.includes('mauticSegment')) !== undefined
															? Lodash.get(notification, 'tags', []).find(tag => tag.name.includes('mauticSegment')).name.replace('mauticSegment_', '').replace(/&/g, ',')
															: ""
													}</TableCell>
												{notificationType === 'scheduled' &&
													<TableCell>
														<IconButton label="Cancelar" onClick={() => { this.openExcludeDialog(notification.id) }} primary >
															<DeleteIcon color="secondary" />
														</IconButton>
													</TableCell>
												}
											</TableRow>

										))}
									</TableBody>
								</Table>
							</TableContainer>
						)
					}
				</Card>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/NotificationList.js